<template>
  <h4
    v-if="subHeader"
    class="CardSubHeader"
    :class="subHeader.class"
    :style="calculatedStyle"
    v-html="$t(subHeader.text)"
  />
</template>

<script>
export default {
  name: 'card-sub-header',
  props: {
    subHeader: {
      type: Object
    }
  },
  computed: {
    calculatedStyle() {
      if (this.subHeader.style && this.subHeader.style.sm && this.$mq === 'sm') {
        return { ...this.subHeader.style, ...this.subHeader.style.sm }
      } else if (this.subHeader.style && this.subHeader.style.lg && this.$mq === 'lg') {
        return { ...this.subHeader.style, ...this.subHeader.style.lg }
      } else {
        return this.subHeader.style
      }
    }
  }
}
</script>

<style lang="scss">
</style>
